import qoalaStorage from '~/core/Storage';

export default {
  setLifeInsuranceData(state, value) {
    state.lifeInsuranceData = value;
    qoalaStorage.setItem('lifeInsuranceData', JSON.stringify(value));
  },
  setListProduct(state, value) {
    state.listProduct = value;
    qoalaStorage.setItem('lifeInsuranceProduct', JSON.stringify(state.listProduct));
  },
  setProductDetail(state, value) {
    state.productDetail = value;
    qoalaStorage.setItem('productDetailLife', JSON.stringify(state.productDetail));
  },
  clearData(state) {
    state.lifeInsuranceData = {};
    state.listProduct = [];
    state.productDetail = {};
    qoalaStorage.removeItem('lifeInsuranceData');
    qoalaStorage.removeItem('lifeInsuranceProduct');
    qoalaStorage.removeItem('productDetailLife');
  }
};
